import axios from "axios";
import appSettings from '../constants/app.constants'

export const client = axios.create({
	baseURL: appSettings.apiUrl 
})